export default __webpack_public_path__ + "static/media/bat2.d42fb924.jpg";